import React from 'react';

interface FilledIconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
}

// Filled/Solid style icons
const filledIconData: Record<string, { svg: string; viewBox: string }> = {
  // 2026-11-03: 화면에서 이 이름들을 쓰는데 모음에 없어 아무것도 안 그려지던 것(새 분석 시작의 +, 7일 안내 i, 만료 표시, 사진 없는 프로필, 위치·휴대폰)
  plus: {
    svg: `<path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  info: {
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "x-circle": {
    svg: `<path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  user: {
    svg: `<path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "map-pin": {
    svg: `<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  smartphone: {
    svg: `<path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  layers: {
    svg: `<path d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  shield: {
    svg: `<path d="M12 2L3.5 7v6c0 4.67 3.5 9.02 8.5 10 5-0.98 8.5-5.33 8.5-10V7L12 2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  lock: {
    svg: `<path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2V10c0-1.1-0.9-2-2-2zM12 17c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  database: {
    svg: `<path d="M12 3C7 3 3 4.79 3 7s4 4 9 4 9-1.79 9-4-4-4-9-4zm0 16c-5 0-9-1.79-9-4v3c0 2.21 4 4 9 4s9-1.79 9-4v-3c0 2.21-4 4-9 4zm0-5c-5 0-9-1.79-9-4v3c0 2.21 4 4 9 4s9-1.79 9-4v-3c0 2.21-4 4-9 4z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  activity: {
    svg: `<path d="M9 2v6h2V4h2v5h2V6h2v3h2V7h2v13c0 1.1-0.9 2-2 2H5c-1.1 0-2-0.9-2-2V7h2v2h2V6h2v3z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  users: {
    svg: `<path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  globe: {
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-0.49-7-3.85-7-7.93 0-0.62 0.08-1.21 0.21-1.79L9 15v1c0 1.1 0.9 2 2 2v1.93zm6.9-2.54c-0.26-0.81-1-1.39-1.9-1.39h-1v-3c0-0.55-0.45-1-1-1H8v-2h2c0.55 0 1-0.45 1-1V7h2c1.1 0 2-0.9 2-2v-0.41c2.93 1.19 5 4.06 5 7.41 0 2.08-0.8 3.97-2.1 5.39z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  rocket: {
    svg: `<path d="M9.19 6.35c-2.04 2.29-3.44 5.58-3.57 5.89L2 10.69l4.05-4.05c0.47-0.47 1.15-0.68 1.81-0.55L9.19 6.35zm11.17 6.33c-0.13-0.31-3.28-5.53-5.57-3.57l0.26-1.33c0.13-0.66-0.08-1.34-0.55-1.81L10.45 2l1.55 3.62c0.31 0.13 3.6 1.53 5.89 3.57l1.33-0.26c0.66-0.13 1.34 0.08 1.81 0.55L22 10.45l-3.62 1.55zm-3.83 2.83L20 19l-1.5 1.5c-0.44 0.44-1.08 0.62-1.68 0.49l-3.54-0.78-0.78-3.54c-0.13-0.6 0.05-1.24 0.49-1.68L14.5 13.5l3.54 0.78 0.78 3.54c0.13 0.6-0.05 1.24-0.49 1.68zm-5.03 1.01l0.98 4.43-2.05 2.05-4.43-0.98c-0.36-0.08-0.58-0.44-0.51-0.8l0.87-3.92 3.92-0.87c0.36-0.07 0.72 0.15 0.8 0.51z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  target: {
    svg: `<circle cx="12" cy="12" r="3" fill="currentColor"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor"/><circle cx="12" cy="12" r="5" fill="currentColor" opacity="0.3"/>`,
    viewBox: "0 0 24 24"
  },
  star: {
    svg: `<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-0.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  heart: {
    svg: `<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  search: {
    svg: `<path d="M15.5 14h-0.79l-0.28-0.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-0.59 4.23-1.57l0.27 0.28v0.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  clock: {
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0.5-13H11v6l5.25 3.15 0.75-1.23-4.5-2.67z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  check: {
    svg: `<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "check-circle": {
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "arrow-right": {
    svg: `<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "arrow-left": {
    svg: `<path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "alert-circle": {
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  zap: {
    svg: `<path d="M7 2v11h3v9l7-12h-4l4-8z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  eye: {
    svg: `<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  cpu: {
    svg: `<path d="M9 2v2H7c-1.1 0-2 0.9-2 2v2H2v2h3v2H2v2h3v2c0 1.1 0.9 2 2 2h2v3h2v-3h2v3h2v-3h2c1.1 0 2-0.9 2-2v-2h3v-2h-3v-2h3V8h-3V6c0-1.1-0.9-2-2-2h-2V2h-2v2h-2V2H9zm8 14H7V6h10v10zm-8-2h6V8H9v6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "trending-up": {
    svg: `<path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  award: {
    svg: `<path d="M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V21l2-1 2 1v-4.23c4.06-0.64 7-2.53 7-4.77 0-2.76-4.48-5-10-5zm0 8c-3.87 0-7-1.79-7-3s3.13-3 7-3 7 1.79 7 3-3.13 3-7 3z" fill="currentColor"/><circle cx="12" cy="12" r="3" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  building: {
    svg: `<path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  briefcase: {
    svg: `<path d="M20 6h-4V4c0-1.11-0.89-2-2-2h-4c-1.11 0-2 0.89-2 2v2H4c-1.11 0-1.99 0.89-1.99 2L2 19c0 1.11 0.89 2 2 2h16c1.11 0 2-0.89 2-2V8c0-1.11-0.89-2-2-2zm-10-2h4v2h-4V4zm10 15H4v-2h16v2zm0-5H4V8h16v6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  wifi: {
    svg: `<path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  loader: {
    svg: `<path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" fill="none" stroke="currentColor" stroke-width="2"/>`,
    viewBox: "0 0 24 24"
  },
  sparkles: {
    svg: `<path d="M12 2l2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z" fill="currentColor"/><path d="M5 11l1 3h3l-2.5 2 1 3-2.5-2-2.5 2 1-3L1 14h3z" fill="currentColor" opacity="0.6"/><path d="M19 11l1 3h3l-2.5 2 1 3-2.5-2-2.5 2 1-3-2.5-2h3z" fill="currentColor" opacity="0.6"/>`,
    viewBox: "0 0 24 24"
  },
  instagram: {
    svg: `<path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4c0 3.2-2.6 5.8-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8C2 4.6 4.6 2 7.8 2m-.2 2C5.61 4 4 5.61 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8c1.99 0 3.6-1.61 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5c0.69 0 1.25 0.56 1.25 1.25S17.14 8 16.45 8 15.2 7.44 15.2 6.75s0.56-1.25 1.25-1.25M12 7c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0 2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  download: {
    svg: `<path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  home: {
    svg: `<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "file-text": {
    svg: `<path d="M14 3H6C4.9 3 4 3.9 4 5v14c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2V9l-6-6zm4 16H6V5h7v5h5v9zm-6-5H8v2h4v-2zm4-2H8v2h8v-2zm0-2H8v2h8v-2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  trash: {
    svg: `<path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1 0.9 2 2 2h8c1.1 0 2-0.9 2-2V7z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "credit-card": {
    svg: `<path d="M20 4H4c-1.11 0-1.99 0.89-1.99 2L2 18c0 1.11 0.89 2 2 2h16c1.11 0 2-0.89 2-2V6c0-1.11-0.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  calendar: {
    svg: `<path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99 0.9-1.99 2L3 19c0 1.1 0.89 2 2 2h14c1.11 0 2-0.9 2-2V5c0-1.1-0.89-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "alert-triangle": {
    svg: `<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "chart-bar": {
    svg: `<path d="M3 5h2v14H3V5zm4 6h2v8H7v-8zm4-6h2v14h-2V5zm4 2h2v12h-2V7z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "user-plus": {
    svg: `<path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "message-circle": {
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12c0 1.54 0.36 2.98 0.97 4.29L1 23l6.71-1.97c1.31 0.61 2.75 0.97 4.29 0.97 5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.32 0-2.54-0.32-3.62-0.88L7 20l0.88-1.38C7.32 17.54 7 16.32 7 15c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "external-link": {
    svg: `<path d="M19 19H5V5h7V3H5c-1.11 0-2 0.9-2 2v14c0 1.1 0.89 2 2 2h14c1.11 0 2-0.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "refresh": {
    svg: `<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-0.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14 0.69 4.22 1.78L13 11h7V4l-2.35 2.35z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "settings": {
    svg: `<path d="M19.14 12.94c0.04-0.3 0.06-0.61 0.06-0.94 0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14 0.23-0.41 0.12-0.61l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39 0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4 2.81c-0.04-0.24-0.24-0.41-0.48-0.41h-3.84c-0.24 0-0.43 0.17-0.47 0.41L9.25 5.35C8.66 5.59 8.12 5.92 7.63 6.29L5.24 5.33c-0.22-0.08-0.47 0-0.59 0.22L2.74 8.87C2.62 9.08 2.66 9.34 2.86 9.48l2.03 1.58C4.84 11.36 4.8 11.69 4.8 12s0.02 0.64 0.07 0.94l-2.03 1.58c-0.18 0.14-0.23 0.41-0.12 0.61l1.92 3.32c0.12 0.22 0.37 0.29 0.59 0.22l2.39-0.96c0.5 0.38 1.03 0.7 1.62 0.94l0.36 2.54c0.05 0.24 0.24 0.41 0.48 0.41h3.84c0.24 0 0.44-0.17 0.47-0.41l0.36-2.54c0.59-0.24 1.13-0.56 1.62-0.94l2.39 0.96c0.22 0.08 0.47 0 0.59-0.22l1.92-3.32c0.12-0.22 0.07-0.47-0.12-0.61L19.14 12.94zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6S13.98 15.6 12 15.6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "camera": {
    svg: `<path d="M12 15c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm4-7h-1l-1-1H10L9 8H8c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h8c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "grid-3x3": {
    svg: `<path d="M3 3h6v6H3V3zm8 0h6v6h-6V3zm8 0h6v6h-6V3zM3 11h6v6H3v-6zm8 0h6v6h-6v-6zm8 0h6v6h-6v-6zM3 19h6v6H3v-6zm8 0h6v6h-6v-6zm8 0h6v6h-6v-6z" fill="currentColor"/>`,
    viewBox: "0 0 28 28"
  },
  "verified": {
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "bar-chart": {
    svg: `<path d="M3 13h2v8H3v-8zm4-6h2v14H7V7zm4-6h2v20h-2V1zm4 8h2v12h-2V9z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "play": {
    svg: `<path d="M8 5v14l11-7z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "image": {
    svg: `<path d="M21 19V5c0-1.1-0.9-2-2-2H5c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "share": {
    svg: `<path d="M18 16.08c-0.76 0-1.44 0.3-1.96 0.77L8.91 12.7c0.05-0.23 0.09-0.46 0.09-0.7s-0.04-0.47-0.09-0.7l7.05-4.11c0.54 0.5 1.25 0.81 2.04 0.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 0.24 0.04 0.47 0.09 0.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c0.79 0 1.5-0.31 2.04-0.81l7.12 4.16c-0.05 0.21-0.08 0.43-0.08 0.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "maximize": {
    svg: `<path d="M15 3h6v6l-2-2-4 4-2-2 4-4-2-2zM9 21H3v-6l2 2 4-4 2 2-4 4 2 2z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "x": {
    svg: `<path d="M18.3 5.71c-0.39-0.39-1.02-0.39-1.41 0L12 10.59 7.11 5.7c-0.39-0.39-1.02-0.39-1.41 0-0.39 0.39-0.39 1.02 0 1.41L10.59 12 5.7 16.89c-0.39 0.39-0.39 1.02 0 1.41 0.39 0.39 1.02 0.39 1.41 0L12 13.41l4.89 4.89c0.39 0.39 1.02 0.39 1.41 0 0.39-0.39 0.39-1.02 0-1.41L13.41 12l4.89-4.89c0.38-0.38 0.38-1.02 0-1.4z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "link": {
    svg: `<path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "unlink": {
    svg: `<path d="M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-0.98 2.63-2.31 2.96l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16v-2zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "chevron-down": {
    svg: `<path d="M7.41 8.84L12 13.42l4.59-4.58L18 10.25l-6 6-6-6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "copy": {
    svg: `<path d="M16 1H4c-1.1 0-2 0.9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h11c1.1 0 2-0.9 2-2V7c0-1.1-0.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "hard-drive": {
    svg: `<path d="M20 8h-2.81c-0.45-0.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-0.96 0.06-1.41 0.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4c-1.11 0-2 0.89-2 2v8c0 1.11 0.89 2 2 2h16c1.11 0 2-0.89 2-2v-8c0-1.11-0.89-2-2-2zm-8 2c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2zm6 8H6v-6h12v6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "history": {
    svg: `<path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89 0.07 0.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-0.79-4.95-2.05l-1.41 1.41C8.22 19.94 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54 0.72-1.21-3.5-2.08V8H12z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "dollar-sign": {
    svg: `<path d="M11.8 10.9c-2.27-0.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44 0.85 2.5 2.1h2.21c-0.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94 0.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5 0.6 3 1.48 3 2.41 0 0.69-0.49 1.79-2.7 1.79-2.06 0-2.87-0.92-2.98-2.1h-2.2c0.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-0.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "gift": {
    svg: `<path d="M20 6h-2.18c0.11-0.31 0.18-0.65 0.18-1a2.996 2.996 0 0 0-5.5-1.65l-0.5 0.67-0.5-0.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 0.35 0.07 0.69 0.18 1H4c-1.11 0-1.99 0.89-1.99 2L2 19c0 1.11 0.89 2 2 2h16c1.11 0 2-0.89 2-2V8c0-1.11-0.89-2-2-2zm-5-2c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM9 4c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  },
  "percent": {
    svg: `<path d="M7.5 11C9.43 11 11 9.43 11 7.5S9.43 4 7.5 4 4 5.57 4 7.5 5.57 11 7.5 11zm0-5C8.33 6 9 6.67 9 7.5S8.33 9 7.5 9 6 8.33 6 7.5 6.67 6 7.5 6zM16.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5 1.5 0.67 1.5 1.5-0.67 1.5-1.5 1.5zM19.41 4.59L4.59 19.41 6 20.82 20.82 6l-1.41-1.41z" fill="currentColor"/>`,
    viewBox: "0 0 24 24"
  }
};

export const FilledIcon: React.FC<FilledIconProps> = ({ 
  name, 
  size = 24, 
  color = 'currentColor', 
  className = ''
}) => {
  const icon = filledIconData[name];
  
  if (!icon) {
    console.warn(`Filled icon "${name}" not found`);
    return null;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox={icon.viewBox}
      className={`filled-icon filled-icon-${name} ${className}`}
      dangerouslySetInnerHTML={{ __html: icon.svg.replace(/currentColor/g, color) }}
    />
  );
};

// Export icon names for TypeScript support
export type FilledIconName = keyof typeof filledIconData;

// Export all available icon names
export const filledIconNames = Object.keys(filledIconData) as FilledIconName[];